/**
 * Returns the CSS text for plans-widget according to the container width.
 *
 * @param {Number} containerWidth: Container width as number
 * @param {String} containerClass: Widget root element class
 * @param {String} widgetClass: Widget element class
 * @returns {String}
 */
export default function getStyle(containerWidth, containerClass, widgetClass) {
  const baseCss = `
    .${containerClass} {
      width: 100%;
      margin: 0 auto;
      padding-top: 10px;
    }
    .${containerClass}__title,
    .${containerClass}__disclaimer {
      text-align: center;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .${containerClass}__title {
      line-height: 1.2;
      font-size: 24px;
    }
    .${containerClass}__disclaimer {
      line-height: 1.45;
      font-size: 12px;
      color: #9d9fa2;
    }`;

  const containerClassList = `${containerClass}__list`;

  let customCss = `
    .${containerClassList} > .${widgetClass} {
      width: 100%;
    }`;

  if (containerWidth >= 576 && containerWidth < 992) {
    customCss = `
    .${containerClassList} > .${widgetClass} {
      width: 32.66%;
    }
    .${containerClassList} > .${widgetClass}:not(:nth-child(3n+1)) {
      margin-left: 1%;
    }`;
  } else if (containerWidth >= 992) {
    customCss = `
    .${containerClass} {
      max-width: 992px;
    }
    .${containerClassList} > .${widgetClass} {
      width: 24.25%;
    }
    .${containerClassList} > .${widgetClass}:not(:nth-child(4n+1)) {
      margin-left: 1%;
    }`;
  }

  return baseCss + customCss;
}
